import _ from 'underscore';
import jQuery from 'jquery';
import moment from 'moment';
import angular from 'angular';

function PromoterSalesReservationsCtrl($scope, $state, $stateParams, $q, $timeout, alertService, sdkVenueService, sdkUtils, eventService, dateUtilsService, managementUserService, organizationService, userPreferencesService, $location, venueService, urlService, visibilityHelpersService, mapperService, admissionGroupService, modalService) { //eslint-disable-line
  const currentUser = managementUserService.getCurrentUser();
  const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.loading = true;
  $scope.initialLoadFinished = false;
  $scope.addAdmissionGroup = _addAdmissionGroup;
  $scope.updateAdmissionGroup = _updateAdmissionGroup;
  $scope.filterReservations = _filterReservations;
  $scope.changeVenue = function (venue, $event) {
    if ($event) $event.preventDefault();

    if (!venue) return;

    $scope.venueId = venue.id;
    $scope.venue = venue;

    userPreferencesService.setDefaultVenue(venue.id);

    venueService.setCurrentVenue(venue);

    $location.search('venueId', $scope.venue.id);
  };
  $scope.dateRangePicker = {
    date: $scope.currentDateUTC
  };

  $scope.reservationFilterForm = {
    searchTerm: null
  };

  /**
   * @desc on-keyup handler for the search box
   */
  $scope.filterReservationsList = function filterReservationsList() {
    if ($scope.reservationListDataTableInstance && $scope.reservationListDataTableInstance.DataTable) {
      $scope.reservationListDataTableInstance.DataTable.search($scope.reservationFilterForm.searchTerm).draw();
    }
  };

  $scope.$watch('dateRangePicker.date', () => {
    if (!$scope.initialLoadFinished) return;

    $scope.event = null; //remove the event when changing date

    $scope.currentDateUTC = dateUtilsService.toUTCMomentWithoutTime($scope.dateRangePicker.date);

    _updateUrlParams();

    $location.search('eventId', null);
  });

  $q.all([$scope.venuesPromise])
    .then(() => {
      $scope.loading = false;
      $scope.initialLoadFinished = true;

      return _getAdmissionGroups();
    });

  // --------------- LIST VIEW ---------------//
  $scope.reservationListDataTableOptions = {
    paginationType: 'full_numbers',
    displayLength: 50,
    columnDefs: [{
      visible: false,
      targets: 0
    }],
    order: [
      [0, 'asc']
    ],
    drawCallback: function () {
      const api = this.api();
      const rows = api.rows({
        page: 'current'
      }).nodes();
      let last = null;

      api.column(0, {
        page: 'current'
      }).data().each((group, i) => {

        if (last !== group) {
          jQuery(rows).eq(i).before(
            `<tr class="divider"><td colspan="14">${group}</td></tr>`
          );

          last = group;
        }
      });
    }
  };
  $scope.reservationListDataTableInstance = {};

  function _filterReservations(admissionGroup) {
    if (!admissionGroup) return false;

    return true;
  }

  function _updateUrlParams() {
    $location.search('date', dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC));
  }

  function _updateAdmissionGroup(admissionGroup, tabName, $event) {
    if (!admissionGroup) return;

    if ($event) $event.preventDefault();

    modalService.addAdmissionGroup({
        type: 'TABLE',
        admissionGroup: admissionGroup,
        date: $scope.currentDateUTC,
        venue: $scope.venue,
        eventId: $scope.event ? $scope.event.id : null,
        events: $scope.events,
        organizationId: currentUserOrganization.id,
        currentTab: tabName,
        onAddedOrUpdated: function (result) {
          if (!result || !result.admissionGroup) return;

          if (result.deleted) {
            const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
              id: result.admissionGroup.id
            });

            const index = $scope.admissionGroups.indexOf(existingAdmissionGroup);

            $scope.admissionGroups.splice(index, 1);
          } else if (!result.created) {
            const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
              id: result.admissionGroup.id
            });

            if (result.admissionGroup.date !== existingAdmissionGroup.date) {
              //remove the admission group because it's date changed
              const index = $scope.admissionGroups.indexOf(existingAdmissionGroup);
              $scope.admissionGroups.splice(index, 1);

              const admissionGroupDate = moment.utc(result.admissionGroup.date, 'x');

              modalService.admissionGroupNotVisible({
                modalHeader: `Reservation date has been changed to ${admissionGroupDate.format('ddd. MMMM Do')} and is no longer visible.`,
                onBtnClick: function () {
                  $state.go($state.current.name, {
                    date: result.admissionGroup.date,
                    venueId: $scope.venueId
                  }, {
                    reload: true
                  });
                }
              });
            } else if (existingAdmissionGroup) {
              _.extend(existingAdmissionGroup, result.admissionGroup);
            }
          } else {
            $scope.admissionGroups.push(result.admissionGroup);
          }

          _mapAdmissionGroups();

          $scope.admissionGroups = angular.copy($scope.admissionGroups); //needed to force datatables to fully redraw

          alertService.success(result.deleted ? 'Reservation deleted' : 'Reservation saved');
        }
      })
      .catch(() => {
        alertService.error('There was an error creating or updating an admission group');
      });
  }

  function _getAdmissionGroups() {
    const options = {
      venue: $scope.venue.id,
      event: $scope.event ? $scope.event.id : null,
      dateStart: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
      dateEnd: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
      type: ['TABLE'],
      limit: 3000
    };

    return admissionGroupService.list(options)
      .then(admissionGroups => {
        $scope.admissionGroups = _.reject(admissionGroups, {
          status: 'DENIED'
        });

        _mapAdmissionGroups();
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _mapAdmissionGroups() {
    _.map($scope.admissionGroups, admissionGroup => {
      if (admissionGroup.event) {
        const event = $scope.eventsIndexedById[admissionGroup.event];
        admissionGroup.eventName = event ? event.name : 'No Event';
      } else {
        admissionGroup.eventName = 'No Event';
      }
    });
  }

  function _addAdmissionGroup($event) {
    if ($event) $event.preventDefault();

    $scope.currentAdmissionGroup = null;

    $scope.selectedSuggestion = null;

    modalService.addAdmissionGroup({
        type: 'TABLE',
        date: $scope.currentDateUTC,
        venue: $scope.venue,
        eventId: $scope.event ? $scope.event.id : null,
        events: $scope.events,
        organizationId: currentUserOrganization.id,
        addedBy: currentUser.id,
        onAddedOrUpdated: function (result) {
          if (!result || !result.admissionGroup) return;

          if (!result.created) {
            const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
              id: result.admissionGroup.id
            });

            if (existingAdmissionGroup) _.extend(existingAdmissionGroup, result.admissionGroup);
          } else {
            $scope.admissionGroups.push(result.admissionGroup);
          }

          // _calculateAdmissionGroupTotals();
          //
          // _calculateReservationStatuses();
          //
          // updateLayoutTablesByAdmissionGroup(result.admissionGroup);

          _mapAdmissionGroups();

          alertService.success(result.created ? 'Reservation added.' : 'Reservation saved.');
        }
      })
      .catch(() => {
        alertService.error('There was an error updating or creating an admission group');
      });
  }
}

PromoterSalesReservationsCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  '$timeout',
  'alertService',
  'jsSdk.venue',
  'jsSdk.utils',
  'jsSdk.event',
  'dateUtilsService',
  'jsSdk.managementUser',
  'organizationService',
  'userPreferencesService',
  '$location',
  'venueService',
  'urlService',
  'visibilityHelpersService',
  'mapperService',
  'jsSdk.admissionGroup',
  'modalService'
];

export default PromoterSalesReservationsCtrl;



// WEBPACK FOOTER //
// ./src/components/promoter/salesReservations/salesReservationsCtrl.js